<sdps-modal-beta #deleteRuleModal sdps-title="Delete Rule" class="delete-rule-modal" id="delete-rule-modal"
    (closeButtonClick)="onCancelClick()">
    <div slot="modal-body">
        <mm-banners *ngIf="showErrorBanner" class="errorBanner" [bannerText]="[bannerErrorText]" [type]="'error'"
            data-testid="delete-rule-modal-error"></mm-banners>
        <div class="modal-text">
            <p>{{this.createRuleConstants.deleteModalDisclaimerText}}</p>
        </div>
    </div>
    <div slot="modal-footer">
        <button (click)="onCancelClick()" type="button" id="delete-rule-modal-cancel"
            class="sdps-button sdps-button--small sdps-button--secondary">Cancel</button>
        <button (click)="onModalDeleteButtonClick()" type="button" id="delete-rule-modal-submit"
            class="sdps-button sdps-button--primary sdps-button--small">Yes, Delete</button>
    </div>
</sdps-modal-beta>